module.exports = __webpack_public_path__ + "img/img_15.95c4fa23.jpg";